import { GoogleOAuthProvider } from '@react-oauth/google';
import './App.css';
import React from 'react';
import Router from 'Routes/Router';
import * as Sentry from '@sentry/react';
import InternalErrorPage from './Pages/InternalErrorPage';
import { environment } from './Config/config';
import { initSentry } from 'Utils/initSentry';

initSentry(environment);

function App() {
    return (
        <Sentry.ErrorBoundary fallback={<InternalErrorPage />}>
            <GoogleOAuthProvider clientId="838522614716-9rt9ise4cg38emusr6frbdcm46n4m8nn.apps.googleusercontent.com">
                <Router />
            </GoogleOAuthProvider>
        </Sentry.ErrorBoundary>
    );
}

export default App;
